import { IFlattenedCategories, IGetCategoriesItemDto } from './categories.dto';

export function flattenCategories(categories: IGetCategoriesItemDto[]): IFlattenedCategories[] {
    const flatten = [];

    categories?.forEach(category => {
        flatten.push({ ...category, is_sub: category.parent_category > 0 ? 1 : 0 } as IFlattenedCategories);
        const children = category.sub_category || category.children;
        if (children && children.length > 0) {
            flatten.push(...flattenCategories(children));
        }
    });

    return flatten;
}
